import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section className="border-b border-line bg-carbon py-8 sm:py-10" data-id="element-185" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-186" data-mp="3fym68hdq8w2r">
        <h2 className="text-center text-[24px] font-bold leading-none text-white sm:text-[38px]" data-id="element-187" data-mp="3b0koq0vy94te">
          What technicians say{' '}
          <span className="text-brandorange" data-id="element-188" data-mp="36z9469rxn9s2">at the bench</span>
        </h2>

        <div className="mt-5 grid gap-3 lg:grid-cols-2" data-id="element-189" data-mp="3205zwrjs17l5">
          {testimonials.map((testimonial, i) => <article key={testimonial.name} className={`flex flex-col border border-line bg-panel2 p-4 ${i === 0 ? 'lg:col-span-2' : ''}`} data-id="element-190" data-mp="2x09watezri64" data-mpi={i}>
              <div className="flex gap-0.5" aria-label="5 out of 5" data-id="element-191" data-mp="v8dl5kwqkabv">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 text-mod-yellow" fill="currentColor" strokeWidth={0} data-id="element-192" data-mp="qav8pkjifcz4" />)}
              </div>
              <p className="mt-2 text-[13.5px] font-medium leading-snug text-white/90 sm:text-[15px]" data-id="element-193" data-mp="780ivmr7388w">
                “{testimonial.quote}”
              </p>
              <div className="mt-auto flex items-center gap-3 pt-3" data-id="element-194" data-mp="c73rtiaapym5">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center bg-brandorange font-display text-[15px] text-white" aria-hidden="true" data-id="element-195" data-mp="zxhaii6zql42">
                  {testimonial.name.charAt(0)}
                </span>
                <div data-id="element-196" data-mp="v57m56lixt3w">
                  <p className="font-display text-[14px] uppercase leading-none text-white" data-id="element-197" data-mp="v4o65vffpesi">
                    {testimonial.name}, {testimonial.age}
                  </p>
                  <p className="mt-1 text-[11.5px] font-semibold uppercase tracking-wide text-metal" data-id="element-198" data-mp="1nmjzyc7v9i94">
                    {testimonial.role} · {testimonial.location}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}